import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import logoLight from 'images/sidenav-lavulogo.svg';
import logoDark from 'images/LavuLogoDark.svg';
import { StellarTheme } from '@lavu-pos/stellar';

const propTypes = {
	showSideNav: PropTypes.bool,
	type: PropTypes.oneOf(['dark', 'light']),
};

const defaultProps = {
	showSideNav: true,
	type: 'light',
};

const LOGO_TYPE = {
	light: logoLight,
	dark: logoDark,
};

const StyledLogo = styled.img`
	height: ${props => (props.showSideNav && '36px') || '1.65rem'};
	width: 78px;

	${StellarTheme.breakpoints.up('xl')} {
		margin-top: -6px;
		height: ${props => (props.showSideNav && '32px') || '1.65rem'};
		width: 92px;
	}
`;

const Logo = ({ showSideNav, type }) => (
	<StyledLogo src={LOGO_TYPE[type]} alt="Lavu logo" showSideNav={showSideNav} />
);

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
